module.exports = __webpack_public_path__ + "media/Video 157.9a3b7010.mp4";